export default {
	"monitoringStrategy": {
		"headerTips": "drag to adjust priority",
		"addTitle": "add temperature monitoring policy",
		"importantMonitor": "whether to focus on monitoring",
		"needTrackable": "temperature must be trackable",
		"needWarning": "whether to monitor",
		"needPickupGoodsTemperature": "must have delivery temperature",
		"needDeliveryGoodsTemperature": "receipt temperature is required",
		"needPickupVehicleTemperature": "must have pickup truck temperature",
		"trackingRequirements": "tracking requirements",
		"monitoringObject": "monitoring object",
		"priority": "priority",
		"originStationType": "departure station type",
		"destStationType": "destination station type",
		"log": "operation record",
		"onlyEnableStrategyTypeSelectTips": "Only monitoring policies in the enabled state can be selected"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/monitoringStrategy/monitoringStrategy.js